/**
 * Whether the signed-in user is an OrgAdmin in the org module: their own
 * `admin_user` row (already in the org subscription batch). Only an OrgAdmin
 * may grant a site Admin role (#241). Reads false until the row arrives, so
 * the Admin choice starts disabled rather than briefly offered and refused.
 */
import { useMemo } from 'react';
import { useSpacetimeDB, useTable } from 'spacetimedb/react';
import { tables as orgTables } from '@sdk/org';

export function useIsOrgAdmin(): boolean {
  const orgState = useSpacetimeDB('org');
  const [rows] = useTable('org', orgTables.adminUser);
  const me = orgState.identity?.toHexString();
  return useMemo(() => {
    if (!me) return false;
    const row = rows.find((r) => r.identity.toHexString() === me);
    return row?.role.tag === 'OrgAdmin';
  }, [rows, me]);
}
